import React from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { Avatar } from "@mui/material";
import dayjs from "dayjs";
import { getTimeZoneAbbreviation } from "../../../utils/getTimeZoneAbbreviation";
import { displayFormattedTotalTimelog } from "../../../utils/helpers";
import UserProfileLink from "../../../components/ui/UserProfileLink";

const ApprovedTimeLog = ({
  timeLogs,
  timeZone,
  approvedBy,
  totalClientTimeApproved,
  totalEngineerTimeApproved,
}) => {
  const timeIn = timeLogs[0] || null;
  const timeOut = timeLogs[timeLogs?.length - 1] || null;

  return (
    <BaseCard
      className={`pt-4 pb-6 xl:px-56 md:px-16 px-5 rounded-lg !mb-[0px]`}
      elevation={1}
    >
      <div className="border-bottom mb-4 flex items-center justify-between pb-1">
        <div className="flex items-center pb-1">
          <h6 className={"!text-secondary"}>Approved By</h6>
          <UserProfileLink
            as="div"
            userId={approvedBy?.id}
            className="flex items-center ml-2"
            linkClassName="cursor-pointer hover:underline"
          >
            <Avatar
              className={`h-[30px] w-[30px] mr-2`}
              src={approvedBy?.url}
            />
            <p>{`${approvedBy?.firstName} ${approvedBy?.lastName}`}</p>
          </UserProfileLink>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-8 items-center mx-8 mt-4">
        <div className="py-1.5 px-8">
          <p className="font-normal text-base text-secondary">
            Customer Approved Time
          </p>
          <div className="flex items-center mt-2">
            <i class="fa-regular fa-circle-check bg-[#686868] rounded px-[3px] py-[2px] text-2xl text-white"></i>
            <div className="ml-2">
              <p className="leading-none mb-1">
                {displayFormattedTotalTimelog(totalClientTimeApproved)}
              </p>
            </div>
          </div>
        </div>

        <div className="py-1.5 px-8 ">
          <p className="font-normal text-base text-primary">
            Engineer Approved Time
          </p>
          <div className="flex items-center mt-2">
            <i class="fa-regular fa-circle-check bg-[#686868] rounded px-[3px] py-[2px] text-2xl text-white"></i>
            <div className="ml-2">
              <p className="leading-none mb-1">
                {displayFormattedTotalTimelog(totalEngineerTimeApproved)}
              </p>
            </div>
          </div>
        </div>

        <div className="py-1.5 px-8 ">
          <p className="font-normal w-36 text-base">Time In</p>
          <div className="flex items-center mt-2">
            <i class="fa-regular fa-clock bg-[#686868] rounded px-[3px] py-[2px] text-2xl text-white"></i>
            <div className="ml-2">
              <p className="leading-none mb-1">
                {timeIn?.checkInTime
                  ? dayjs(timeIn.checkInTime)
                      .tz(timeZone)
                      .format("MMM D, YYYY hh:mm A")
                  : "N/A"}
              </p>
              <p className="leading-none">
                {timeZone} ({getTimeZoneAbbreviation(timeZone)})
              </p>
            </div>
          </div>
        </div>
        <div className="py-1.5 px-8 ">
          <p className="font-normal w-36 text-base">Time Out</p>
          <div className="flex items-center mt-2">
            <i class="fa-regular fa-clock bg-[#686868] rounded px-[3px] py-[2px] text-2xl text-white"></i>
            <div className="ml-2">
              <p className="leading-none mb-1">
                {timeOut
                  ? dayjs(timeOut?.checkOutTime)
                      .tz(timeZone)
                      .format("MMM D, YYYY hh:mm A")
                  : "N/A"}
              </p>
              <p className="leading-none">
                {timeZone} ({getTimeZoneAbbreviation(timeZone)})
              </p>
            </div>
          </div>
        </div>
      </div>
    </BaseCard>
  );
};

export default ApprovedTimeLog;
